import toPascalCase from '../toPascalCase';

const getSVGIconClassName = (icon: string) => `hz-SvgIcon hz-SvgIcon${toPascalCase(icon)}`;

export default getSVGIconClassName;
